import { mapJsonQuery } from './jsonQuery';
import { IJsonQuerySchema } from '../repositories/newbuilding-promos/entities/json_query/JsonQuerySchema';
import { ISearchPromosV2ResponseSchema } from '../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { TFilterSelector } from '../types/filterSelectors';
import { IJsonQuery } from '../types/jsonQuery/jsonQuery';
import { containsJsonQuery } from '../utils/jsonQuery/containsJsonQuery';
import { removeEmptyKeys } from '../utils/jsonQuery/removeEmptyKeys';

export const mapFilterSelectors = (promosResponse: ISearchPromosV2ResponseSchema): TFilterSelector[] => {
  const jsonQuery: IJsonQuery = mapJsonQuery(promosResponse.jsonQuery);

  return promosResponse.filterSelectorsV2.map(selector => {
    if (selector.dialog) {
      const { name, dialog } = selector;

      const filters = dialog.filters.map(filter => ({
        countText: filter.countText,
        jsonQuery: removeEmptyKeys(mapJsonQuery(filter.jsonQuery)),
        name: filter.name,
        isActive: containsJsonQuery(jsonQuery, removeEmptyKeys(mapJsonQuery(filter.jsonQuery))),
      }));

      const isActive = filters.some(filter => filter.isActive);

      return {
        dialog: {
          filters,
          title: dialog.title,
        },
        isActive,
        name,
      };
    }

    const chipJsonQuery = removeEmptyKeys(mapJsonQuery(selector.jsonQuery as IJsonQuerySchema));
    const isActive = containsJsonQuery(jsonQuery, chipJsonQuery);

    return {
      jsonQuery: chipJsonQuery,
      isActive,
      name: selector.name,
    };
  });
};
